// extracted by mini-css-extract-plugin
export default {"Subtitle":"Subtitle_Subtitle__f7D+W","showSubtitle":"Subtitle_showSubtitle__ahj83"};